import ProductLoveToggle from 'components/Product/ProductLove/ProductLoveToggle/ProductLoveToggle';

export default ProductLoveToggle;
